__turbopack_context__.v({
  "content": "dropdown-menu-module__7TDp4G__content",
  "item": "dropdown-menu-module__7TDp4G__item",
  "itemActive": "dropdown-menu-module__7TDp4G__itemActive",
  "label": "dropdown-menu-module__7TDp4G__label",
  "separator": "dropdown-menu-module__7TDp4G__separator",
  "slideDown": "dropdown-menu-module__7TDp4G__slideDown",
});
